import { render, staticRenderFns } from "./signing.vue?vue&type=template&id=72ec88ff&scoped=true&"
import script from "./signing.vue?vue&type=script&lang=js&"
export * from "./signing.vue?vue&type=script&lang=js&"
import style0 from "./signing.vue?vue&type=style&index=0&id=72ec88ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ec88ff",
  null
  
)

export default component.exports